"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importDefault(require("react"));
var AuthMenu_1 = require("./AuthMenu");
var NotAuthMenu_1 = require("./NotAuthMenu");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RightMenu = function (_a) {
    var isNotFoundPage = _a.isNotFoundPage, languages = _a.languages, searchRightMobile = _a.searchRightMobile, showSignUp = _a.showSignUp;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var isLoading = (0, swr_hooks_1.useUser)().isLoading;
    if (isLoading)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.authContainer }, isAuth ? (react_1.default.createElement(AuthMenu_1.AuthMenu, { searchRightMobile: searchRightMobile })) : (react_1.default.createElement(NotAuthMenu_1.NotAuthMenu, { searchRightMobile: searchRightMobile, languages: languages, showSignUp: showSignUp }))));
};
exports.default = react_1.default.memo(RightMenu);
